import React from "react";
import Context from "../../../context/Context";
import * as component from "../../util/component";

export default class IcsLinK extends React.Component {

  constructor(props) {
    super(props);
    this.state = component.newState({});
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  render() {
    const i18n = Context.instance.i18n;
    const icsInfo = this.props.icsInfo;
    const hashref = "#";
    let node = null;
    if (icsInfo && typeof icsInfo.href === "string") {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        if (icsInfo.blob) {
          node = (
            <a href={hashref} role="button"
              className="i-button"
              onClick={() => {
                window.navigator.msSaveOrOpenBlob(icsInfo.blob,icsInfo.filename);
              }}
            >
              <span>{i18n.events.details.addToCalendar}</span>
            </a>
          );
        }
      } else {
        node = (
          <a href={icsInfo.href} download={icsInfo.filename}
            className="i-button"
            role="button" rel="noopener noreferrer" target="_blank"
          >
            <span>{i18n.events.details.addToCalendar}</span>
          </a>
        );
      }
    }
    return node;
  }

}
